<template>
    <div id="about-us-slider-one" class="container-size-fixer">
        <div class="title">
            <ul>
                <li>
                    <img width="30" height="30" src="../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                </li>
                <li>
                   نظر موکلین
                    <span>
                کانادا از ایران
            </span>
                </li>
            </ul>
        </div>
        <flickity  v-if="items"  class="flickity" ref="flickity" :options="flickityOptions">
            <div class="carousel-cell" v-for="item in items" :key="item">
                <div class="section-one" :style="{backgroundImage : 'url(' + $store.state.base_urls.webUploads + item.image + ')'}" ></div>
                <div class="section-two">
                    <div class="comment-content">
                        <img class="comment-content-img-top" width="50" height="40" src="../assets/new/New/Icon/QuotationmarkCopy.png" alt="">
                        <img class="comment-content-img-bottom" width="50" height="40" src="../assets/new/New/Icon/QuotationmarkCopy.png" alt="">
                        {{item.opinion}}
                    </div>
                    <div class="comment-sender">
                        <span class="name">
                           {{item.name}}
                        </span>
                        <span class="subject">
                           {{item.subject}}
                        </span>
                    </div>
                </div>
            </div>
        </flickity>
    </div>
    <div v-if="loadingMood">
        <img style="height: auto;width: 50%;margin-top: -170px;" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
    </div>
</template>

<script>
    // @ is an alias to /src
    import Flickity from 'vue-flickity'
    import axios from 'axios'
    export default {
        name: "AboutUsSliderOne",
        components:{
            Flickity
        },
        data () {
            return {
                flickityOptions: {
                    initialIndex: 3,
                    prevNextButtons: false,
                    pageDots: true,
                    wrapAround:false,
                    freeScroll: false,
                    autoPlay: 2000,
                    rightToLeft: true,
                    arrowShape: {
                        x0: 30,
                        x1: 45, y1: 20,
                        x2: 55, y2: 20,
                        x3: 40
                    }
                    // any options from Flickity can be used
                },
                alertContent: null,
                loadingMood: false,
                infos:null,
                items:null
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getClientsOpinions',);
                    this.loadingMood = false;
                    this.items = response.data.results;
                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style lang="scss" scoped>
    #about-us-slider-one{padding: 0 15px 0 15px!important;}
    .title{
        margin-top: 30px;
        width: 100%;
        text-align: right;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;

        ul{
            /*display: flex;*/
            /*align-items: center;*/
            /*justify-content: right;*/
            padding: 0;
            list-style-type: none;

            li{

                padding: 5px;
                img{
                    margin-top: 5px;
                    width: 9px!important;
                    height: auto!important;
                }
                display: inline-block;
                span{
                    color: #cc171d;
                }
            }
        }

    }
    .comment-content-img-top{
        position: absolute;
        left: 15px;
        bottom: 15px;
    }
    .comment-content-img-bottom{
        position: absolute;
        transform: rotate(180deg);
        right: 15px;
        top: 15px;
    }
    .comment-sender{
        min-height:50px;
        height:auto;
        width: 100%;
        padding: 15px;
        .name{
            width: 100%;
            height: auto;
            display: block;
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #162336;
        }
        .subject{
            width: 100%;
            height: auto;
            display: block;
            opacity: 0.5;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #162336;
        }
    }

    .comment-content{
        width: 100%;
        min-height: 50px;
        padding: 27px 20px;
        position: relative;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }
    .section-one{
        height: 169px;
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        border-top-right-radius: 10px;
        border-top-left-radius: 10px;
    }
    .section-two{
        min-height: 219px;
        height: auto;
        width: 100%;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    #slider-title{
        text-align: right;
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-top: 0;
    }
    .flickity{
        margin-top: 57px;
    }
    #about-us-slider-one{
        background-color: white;
        width: 100%;
        height: auto;
        margin:  0 auto 90px auto;
        padding: 50px 15px 46px 15px;
    }
    .carousel-cell{
        border: solid 1px #162336;
        background-size:cover ;
        background-repeat: no-repeat;
        position: relative;
        border-radius: 10px;
        width: 320px!important;
        min-height: 388px!important;
        height: auto;
        margin: 15px;
    }
    .carousel-cell .is-selected {
        box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.12);
        border: solid 2px #fe7063;
        background-color: rgba(22, 35, 54, 0.9);
    }

    .carousel-cell.is-selected > .slider-cover {
        opacity: 0.8!important;
    }

    @media (max-width: 1300px) {
        #about-us-slider-one{
            padding: 50px 15px 46px 15px;
        }
    }
</style>